import { URLASSOLUTO, URLASSOLUTOISTITUZIONALE } from "./variables";
import Swal from "./sweetalert2";
import bootstrapvalidation from "./validate";
//import './jquery.flexdatalist'; // messo script localmente perchè non funziona da node_modules...

$(document).ready(function () {
    let hash = window.location.hash;

    if ($(hash + "L").length) {
        $("html, body").animate(
            {
                scrollTop: $(hash + "L").offset().top,
            },
            1000
        );
    }
    // fade out background preloader
    $("#preload").fadeOut(function () {
        $(".headerBottom").addClass("isvisible");
    });

    $("body").on("change", ".languageselector", function () {
        var languageselected = $(this).find(":selected").data("path");
        if (typeof languageselected !== "undefined") {
            window.location.href = languageselected;
        }
    });
    $("body").on("click", ".expandfilter", function () {
        $(this).closest(".filterblock").toggleClass("itemselectable");
    });

    $("body").on("click", ".buttoniniziaheader", function (e) {
        $("html, body").animate(
            {
                //scrollTop: $(this).offset().top + $(this).height(),
                scrollTop: $('main').offset().top
            },
            1000
        );
    });

    $("body").on("click", ".recupera-password", function (e) {
        $(this).closest("form").removeClass("was-validated");
        $(".recupera-password-toggle").slideToggle();
        $(this).closest("form").find("#username").prop("required", false);
        $(this).closest("form").find("#password").prop("required", false);
        $(this).closest("form").find("#Email").prop("required", true);
    });

    $("body").on("change", ".check-spedizione", function (e) {
        if ($(this).is(":checked")) {
            $(".check-spedizione-toggle").fadeIn();
            $(".check-spedizione-toggle .required").prop("required", true);
        } else {
            $(".check-spedizione-toggle").fadeOut();
            $(".check-spedizione-toggle .required").prop("required", false);
        }
        $(this).closest("form").removeClass("was-validated");
    });

    $("body").on("click", ".click-spedizione", function (e) {
        $(this).closest("form").removeClass("was-validated");
        $(".click-spedizione-toggle").slideToggle();
        $(this)
            .closest("form")
            .find("input")
            .each(function (index) {
                if ($(this).is(":visible") && $(this).hasClass("required")) {
                    $(this).prop("required", true);
                } else {
                    $(this).prop("required", false);
                }
            });
    });

    $("body").on("click", ".non-registrato", function (e) {
        $(".non-registrato-toggle").slideToggle();
    });

    $("body").on("change", "#Azienda", function (e) {
        $(this).closest("form").removeClass("was-validated");
        var valAzienda = $(this).val();
        if (valAzienda == "1") {
            $(".check-azienda-show").parent().fadeIn();

            var labelchanged = "";
            $(".check-azienda").each(function (index) {
                $(this).prop("required", true);
                labelchanged = $(this).data("label");
                $(this)
                    .parent()
                    .find("label")
                    .html(labelchanged + " *");
            });
        } else {
            $(".check-azienda-show").parent().fadeOut();

            var labelchanged = "";
            $(".check-azienda").each(function (index) {
                $(this).prop("required", false);
                labelchanged = $(this).data("label");
                $(this).parent().find("label").html(labelchanged);
            });
        }
    });

    $("body").on("change", "select.item-confezione", function (e) {
        let itemnew = $(this).val();
        let itemnewpos = $(this).data("confezione");

        let srcimagebig = $(".composizione-confezione").attr("src");
        let srcimagethumb = $(".composizione-confezione-thumb").attr("src");

        if (itemnew) {
            var srcimagebiga = srcimagebig.split("idp");
            var srcimagethumba = srcimagethumb.split("idp");
            console.log(srcimagebiga);
            if (itemnewpos == "0") {
                srcimagebiga[1] = itemnew + "x";
                srcimagethumba[1] = itemnew + "x";
            } else if (itemnewpos == "1") {
                srcimagebiga[2] = itemnew + "x";
                srcimagethumba[2] = itemnew + "x";
            } else if (itemnewpos == "2") {
                var tmpsplit = srcimagebiga[3].split("x");
                tmpsplit[0] = itemnew;
                srcimagebiga[3] = tmpsplit.join("x");
                tmpsplit = srcimagethumba[3].split("x");
                tmpsplit[0] = itemnew;
                srcimagethumba[3] = tmpsplit.join("x");
            }
            let newsrcimagebig = srcimagebiga.join("idp");
            let newsrcimagethumb = srcimagethumba.join("idp");
            $(".composizione-confezione").attr("src", newsrcimagebig);
            $(".composizione-confezione").parent().attr("href", newsrcimagebig);
            $(".composizione-confezione-thumb").attr("src", newsrcimagethumb);
        }
    });

    $(".boxCategory .headerCategory").one("inview", function (event, isInView) {
        var boxCategory = $(this).closest(".boxCategory");
        boxCategory.find(".headerCategory").imagesLoaded(function () {
            boxCategory.find(".headerCategory").addClass("isvisible");
            boxCategory.find(".headerCategoryImage").addClass("isvisible");
        });
    });

    $(".boxRecipe1 .headerRecipe").one("inview", function (event, isInView) {
        var boxRecipe1 = $(this).closest(".boxRecipe1");
        boxRecipe1.find(".headerRecipe").addClass("isvisible");
        boxRecipe1.find(".headerRecipeImage").addClass("isvisible");
    });

    $(".boxRecipeDetail .headerRecipe").one(
        "inview",
        function (event, isInView) {
            var boxRecipe1 = $(this).closest(".boxRecipeDetail");
            boxRecipe1.find(".headerRecipe").addClass("isvisible");
            boxRecipe1.find(".headerRecipeImage").addClass("isvisible");
        }
    );

    if ($(".cursorspecialpointer").length > 0) {
        $("body").mousemove(function (i) {
            var e = i.pageX - 8,
                t = i.pageY - 8;
            $(".cursorspecialpointer").css({
                top: t + "px",
                left: e + "px",
            });
        }),
            $(".cursorspecial").mousemove(function (i) {
                var e = i.pageX,
                    t = i.pageY;
                $(".cursorspecialpointer").css({
                    top: t + "px",
                    left: e + "px",
                }),
                    $(".cursorspecialpointer span").addClass(
                        "cursorspecialpointervisible"
                    );
            }),
            $(".cursorspecial").mouseleave(function (i) {
                $(".cursorspecialpointer span").removeClass(
                    "cursorspecialpointervisible"
                );
            });
    }

    $(".sameheight").boxheight();
    $(".dooverflown").boxoverflown();
    // pagina composizione
    // controllo codici configurazione per evidenziare righe
    $(".check_code").on("change", function (e) {
        let thisCode = $(this).val();
        if (thisCode) {
            //console.log(thisCode);
            // recupero le righe della tabella con questo codice
            $(".table_codes").each(function () {
                let tr_codes = $(this).data("codes");
                let array_codes = tr_codes.split(";");
                $(this).removeClass("selected");
                if (array_codes.includes(thisCode)) {
                    //console.log('si include');
                    $(this).addClass("selected");
                }
            });

            // mostro i prezzi
            let thisSelected = $(this).find(":selected");
            let totalPrice = $(thisSelected).data("prezzooriginale");
            let totalPriceDiscounted = $(thisSelected).data("prezzo");
            //console.log(totalPrice);
            //console.log($('#prezzoOriginario').html());
            $("#prezzoOriginario").html(
                `<small>a partire da</small>&nbsp;<del>${totalPrice}</del>`
            );
            $("#prezzoScontato").html(
                `${totalPriceDiscounted} <span class="piuiva">+ IVA</span>`
            );
            $("#prezzoOriginario2").html(
                `<small>a partire da</small>&nbsp;<del>${totalPrice}</del>`
            );
            $("#prezzoScontato2").html(
                `${totalPriceDiscounted} <span class="piuiva">+ IVA</span>`
            );
            $("#codiceConfigurazione").html(`Cod. ${thisCode}`);

            // aggiorno l'immagine dello slideshow
            let indiceSlide = $("#" + thisCode).data("zoom");
            //console.log(sliderProdotto);
            sliderProdotto.goTo(indiceSlide);
            //console.log(indiceSlide);

            // opacity thumb
            $(".controlSlide").each(function () {
                $(this).removeClass("selected");
            });
            $("#" + thisCode).addClass("selected");

            // aggiorno il form
            let selectedOption = $(thisSelected).html();
            let configuration_id = $(thisSelected).data("id");
            $("#targetProdotto span").html(selectedOption);
            $("#richiedoInformazioniPer").val(selectedOption);
            $("#configuration_id").val(configuration_id);
            $("#configuration_code").val(thisCode);
        }
    });

    // evento su click articolo variante (per aggiunta a form richiesta)
    $(".addArticle").on("click", function (e) {
        let thisArticleId = $(this).data("id");
        let currentArticleId = $("#currentArticleId").val();
        if (thisArticleId == currentArticleId) return;
        $("#currentArticleId").val(thisArticleId);

        // resetto altre selezioni attive
        resetDati(".prontoPerForm");

        $(".table_codes").each(function () {
            $(this).removeClass("selected");
            $(this).find("input").prop("checked", false);
        });
        $(this).addClass("selected");
        $(this).find("input").prop("checked", true);
        //console.log(thisArticleId);

        $.ajax({
            url: URLASSOLUTO + "/gpa/" + thisArticleId,
            method: "GET",
            dataType: "html",
        }).done(function (result) {
            //console.log(result);
            let obj = JSON.parse(result);
            let article_name = obj["name"];
            let article_code = obj["article_code"];
            $("#article_name").val(article_name).removeClass("disabled");
            $("#article_code").val(article_code).removeClass("disabled");
            // aggiorno i campi nascosti del form
            $("#product_article_id").val(thisArticleId);
            //console.log(obj);
            //console.log(article_code);
        });
    });

    // selectConfigurationArticle docce
    $("body").on("click", ".selectConfigurationArticle", function (e) {
        let thisConfigurationCode = $(this).data("configurazione");
        e.stopPropagation();
        //console.log(thisConfigurationCode);
        $(".resettaIcone").css("display", "none");
        $(".box-gruppo-icona")
            .removeClass("selected")
            .addClass("nascondiImmagineIcona");
        $(".icone-nome")
            .removeClass("selected")
            .addClass("nascondiImmagineIcona");
        $(".nascondiDati").css("display", "table");
        $(this)
            .closest(".box-gruppo-icona")
            .removeClass("nascondiImmagineIcona");
        $(this)
            .closest(".icone-nome")
            .addClass("selected")
            .removeClass("nascondiImmagineIcona");
        $(this)
            .closest(".box-gruppo-icona")
            .find(".resettaIcone")
            .css("display", "flex");

        $(".tabellaArticoli tr").css("display", "none");
        $(`.selectCodeConfiguration`).removeClass("selected");
        if (thisConfigurationCode) {
            $(".tabellaArticoli thead tr").css("display", "table-row");
            $(`.${thisConfigurationCode}`).css("display", "table-row");
            $(`.check_${thisConfigurationCode}`).addClass("selected");
        }

        // RECUPERO ELENCO CODICI LATI
        $.ajax({
            url: URLASSOLUTO + "/gpc/" + thisConfigurationCode,
            method: "GET",
            dataType: "html",
        }).done(function (result) {
            let obj = JSON.parse(result);
            let findTr = $(".addArticle:visible");

            // recupero i lati delle ante
            for (let [key, value] of Object.entries(obj)) {
                if (
                    key.includes("codes") &&
                    !key.includes("extended") &&
                    value !== null
                ) {
                    //console.log(`${key}: ${value}`);
                    let side_codes = obj[key];
                    let side_codes_extended = obj[`${key}_extended`];
                    let tempPiatto = key.replace("_codes", "_piatto");
                    let side_piatto = obj[`${tempPiatto}`];
                    let selectClass = $(findTr).find(`select.select_${key}`);

                    $(findTr).find(".addPiatto").html("");
                    $(selectClass).html('<option value="">Seleziona</option>');
                    for (var k in side_codes) {
                        $(selectClass).append(
                            `<option value="${side_codes[k]}" data-piatto="${side_piatto[k]}">${side_codes_extended[k]}</option>`
                        );
                        //console.log(`${k} : ${side_codes[k]}`);
                    }
                    $(selectClass).prop("disabled", false);
                    $(selectClass).selectpicker("refresh");
                }
            }
        });
    });

    // resetta configurazione docce
    $("body").on("click", ".resettaIcone", function () {
        $(".nascondiDati").css("display", "none");
        $(".resettaIcone").css("display", "none");
        $(".box-gruppo-icona")
            .removeClass("selected")
            .removeClass("nascondiImmagineIcona");
        $(".icone-nome")
            .removeClass("selected")
            .removeClass("nascondiImmagineIcona");

        // resetto i lati e piatto
        resetDati();
    });

    $("body").on("click", ".player", function (e) {
        if (!$(this).hasClass("active")) {
            $(".player")
                .not(this)
                .each(function (index) {
                    $(this).removeClass("active");
                    let audioid = $(this).data("audio");
                    let song = document.getElementById(audioid);
                    song.pause();
                    song.currentTime = 0;
                });
            $(this).addClass("active");
            let audioid = $(this).data("audio");
            let song = document.getElementById(audioid);
            song.play();

            console.log("attivato");
        } else {
            $(this).removeClass("active");
            let audioid = $(this).data("audio");
            let song = document.getElementById(audioid);
            song.pause();
            song.currentTime = 0;
        }
    });

    // reset dati selezionati
    function resetDati(prontoPerForm = null) {
        // resetto i lati e piatto
        let selectClass = "";
        let selectFiniture = "";
        let selectClassAll = "";
        if (prontoPerForm) {
            selectClass = $(
                `${prontoPerForm} select.verificaArticoloConfigurazione:not(.finiture)`
            );
            selectFiniture = $(`${prontoPerForm} select.finiture`);
            $(selectClass).val("").selectpicker("refresh");
            $(selectFiniture).val("").selectpicker("refresh");
            $(`${prontoPerForm}.addArticle`).removeClass("prontoPerForm");
            $(`${prontoPerForm} .addPiatto`).html("");
        } else {
            selectClass = $(
                `select.verificaArticoloConfigurazione:not(.finiture)`
            );
            selectFiniture = $("select.finiture");
            selectClassAll = $("select.verificaArticoloConfigurazione");
            if (selectClass) {
                $(selectClass).html('<option value="">Seleziona</option>');
                $(selectClass).prop("disabled", true);
                $(selectClass).selectpicker("refresh");
            }
            $(selectFiniture).val("").selectpicker("refresh");

            $(".addArticle").removeClass("prontoPerForm");
            $(".addPiatto").html("");

            // resetto campi per form preventivo
            [...selectClassAll].forEach((selectElement) =>
                $(`#${selectElement.name}`).val("")
            );
            $("#18_meta_h_mm").val("");
            $("#raggio").val("");
            $("#piatto").val("");
        }
    }

    // verifico se sono state selezionate tutte le opzioni della doccia Agha
    $("body").on("change", ".verificaArticoloConfigurazione", function (e) {
        e.stopPropagation();
        let findTr = $(this).closest(".addArticle:visible");
        let selectClassVisible = $(findTr).find(
            "select.verificaArticoloConfigurazione:visible"
        );
        let heightH = $(findTr).find(".18_meta_h_mm").text();
        let raggio = $(findTr).find(".25_meta_raggio_mm").text();
        let piatto = $(findTr).find(".addPiatto").text();
        let check = true;

        // spread operator ... converte degli elementi DOM in una array che posso loopare
        [...selectClassVisible].forEach((selectElement) => {
            //console.log(selectElement);
            //console.log(selectElement.name);

            let elementVal = $(selectElement).val();

            if ($(selectElement).find(":selected").text() == "Seleziona") {
                //console.log('si esiste lato ma nessun valore selezionato');
                $(`#${selectElement.name}`).val("");
                check = false;
            } else {
                $(`#${selectElement.name}`).val(elementVal);
            }
        });

        $("#18_meta_h_mm").val(heightH);
        $("#raggio").val(raggio);
        $("#piatto").val(piatto);

        if (check) {
            $(findTr).addClass("prontoPerForm");
            setTimeout(function () {
                Swal.fire({
                    title: "Variante doccia configurata!",
                    html: "Hai configurato la tua variante, ora compila il form per inviare il preventivo.",
                });
            }, 300);
        } else {
            $(findTr).removeClass("prontoPerForm");
        }
    });

    // seleziona piatto articolo doccia
    const selectClassPiatto = $(
        "select.verificaArticoloConfigurazione:not(.finiture)"
    );
    $(selectClassPiatto).on("change", function (e) {
        let thisSelected = $(this).find(":selected");
        if (thisSelected) {
            let thisPiatto = $(thisSelected).data("piatto");
            if (thisPiatto) {
                let findTr = $(this).closest(".addArticle");
                if (findTr) {
                    $(findTr).find(".addPiatto").html(thisPiatto);
                }
            }
        }
    });

    // selezione opzioni prodotto
    $(".add_product_options").on("change", function () {
        let thisSelectedOptions = $(this).val();
        // aggiorno campo nascosto opzioni prodotto
        $("#opzioniprodotto").val(thisSelectedOptions);
    });

    $(".controlSlide").on("click", function () {
        $(".controlSlide").each(function () {
            $(this).removeClass("selected");
        });
        $(this).addClass("selected");
    });

    $(".comefunziona").on("click", function () {
        let thisMsg = $(this).data("message");
        Swal.fire({
            title: "Come funziona?",
            html: thisMsg,
        }).then((result) => {});
    });

    // filtri apertura modal sweetalert2
    $("body").on("click", ".cosaCerchi", function () {
        $.ajax({
            url: URLASSOLUTO + "/ricerca-libera/",
            method: "GET",
            dataType: "html",
        }).done(function (result) {
            Swal.fire({
                background: "#fff",
                position: "center",
                showCloseButton: true,
                showConfirmButton: false,
                customClass: {
                    popup: "animated slideInUp faster",
                },
                html: result,
                didOpen: () => {
                    bootstrapvalidation();
                },
            });
        });
    });
});

$(window).resize(function () {
    $(".sameheight").css("height", "auto");
    $(".sameheight").boxheight();
});
